import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SolidRightArrowIcon = (props: IconProps) => (
  <Icon width="5px" height="10px" viewBox="0 0 5 10" {...props}>
    <path d="m0 9.16659 4.16667-4.16667L0 .833252V9.16659Z" />
  </Icon>
);

export default memo(SolidRightArrowIcon);
